<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <navbar>
            <template v-slot:navbarname>
                <b-link
                        :to="{name:'Sliders'}"
                        class="btn btn-primary btn-round">
                    back
                </b-link>
            </template>
        </navbar>

        <h2>New Slider</h2>


        <b-card title="Desktop">
            <template v-if="image_desktop_preview !== null">
                <b-img :src="image_desktop_preview" width="85"></b-img>
            </template>
            <b-form-group
                    :state="!validation.hasError('image_desktop')"
                    :invalid-feedback="validation.errorTitle('image_desktop')"
            >
                <b-form-file @change="onSelectFileDesktop" v-model="image_desktop"></b-form-file>

            </b-form-group>
        </b-card>
        <b-card title="Tablet">
            <template v-if="image_tablet_preview !== null">
                <b-img :src="image_tablet_preview" width="85"></b-img>
            </template>
            <b-form-group
                    :state="!validation.hasError('image_tablet')"
                    :invalid-feedback="validation.errorTitle('image_tablet')"
            >
                <b-form-file @change="onSelectFileTablet" v-model="image_tablet"></b-form-file>
            </b-form-group>
        </b-card>
        <b-card title="Mobile">
            <template v-if="image_mobile_preview !== null">
                <b-img :src="image_mobile_preview" width="85"></b-img>
            </template>
            <b-form-group
                    :state="!validation.hasError('image_mobile')"
                    :invalid-feedback="validation.errorTitle('image_mobile')"
            >
                <b-form-file @change="onSelectFileMobile" v-model="image_mobile"></b-form-file>
            </b-form-group>
        </b-card>
        <b-card title="options">
            <b-form-group label="Link Url">
                <b-input type="url" placeholder="http://example.com" v-model="slider_link"></b-input>
            </b-form-group>
            <b-form-checkbox v-model="is_hide">is hide?</b-form-checkbox>
        </b-card>

        <b-button @click="storeSlider" variant="success">{{$t('saveTitle')}}</b-button>
    </div>
</template>

<script>
    import Navbar from "../Partials/Navbar";
    import Http from '../../Services/HttpService/HttpService'
    import Notificaion from '../../Services/Notification/Nottification'
    import Validation from '../../Services/Validation/Validation'


    export default {
        name: "AddSlider",
        components: {Navbar},
        data() {
            return {
                validation: new Validation(),
                image_desktop_preview: null,
                image_tablet_preview: null,
                image_mobile_preview: null,
                image_desktop: null,
                image_tablet: null,
                image_mobile: null,
                is_hide: false,
                slider_link: null,
            }
        },
        methods: {
            onSelectFileDesktop(event) {
                this.image_desktop_preview = URL.createObjectURL(event.target.files[0]);
            },
            onSelectFileTablet(event) {
                this.image_tablet_preview = URL.createObjectURL(event.target.files[0]);
            },
            onSelectFileMobile(event) {
                this.image_mobile_preview = URL.createObjectURL(event.target.files[0]);
            },
            storeSlider() {
                let fd = new FormData();
                if (this.image_desktop != null) {
                    fd.append("image_desktop", this.image_desktop)
                }
                if (this.image_tablet != null) {
                    fd.append("image_tablet", this.image_tablet)
                }
                if (this.image_mobile != null) {
                    fd.append("image_mobile", this.image_mobile)
                }

                fd.append("is_hide", this.is_hide);
                fd.append("slider_link", this.slider_link);

                Http.post(Http.apiurlV2() + 'slider/store', fd)
                    .then(response => {
                        this.$Progress.finish();
                        if (response.data.status_code === Http.created()) {
                            this.$router.push({name: 'Sliders'});
                            Notificaion.success(response.data.message)
                        } else {
                            this.validation.store(response.data.data);
                            Notificaion.error(response.data.message)

                        }
                    })
                    .catch(error => {
                        this.$Progress.finish();
                    })

            },

        },
    }
</script>

<style scoped>

</style>